export const FEATURES = Object.freeze({
  VUE_APP_PRECONDITION_TOGGLE: 'VUE_APP_PRECONDITION_TOGGLE'
})

export const ENV_TOGGLES = {
  [FEATURES.VUE_APP_PRECONDITION_TOGGLE]: process.env.VUE_APP_PRECONDITION_TOGGLE === 'true'
}

export const isEnabled = (key, toggles = null) => (toggles ? toggles[key] : ENV_TOGGLES[key])
